export default __webpack_public_path__ + "static/wietze-1f9ac759fd4366076d9c40661dff8f61.jpg";